import { useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Select from 'components/select';

const StartingOnSelector = ({ value, onChange }) => {
    const { t } = useTranslation('recurring');

    const months = useMemo(() => [
        {
            id: 1,
            text: t('date:months.January')
        },
        {
            id: 2,
            text: t('date:months.February')
        },
        {
            id: 3,
            text: t('date:months.March')
        },
        {
            id: 4,
            text: t('date:months.April')
        },
        {
            id: 5,
            text: t('date:months.May')
        },
        {
            id: 6,
            text: t('date:months.June')
        },
        {
            id: 7,
            text: t('date:months.July')
        },
        {
            id: 8,
            text: t('date:months.August')
        },
        {
            id: 9,
            text: t('date:months.September')
        },
        {
            id: 10,
            text: t('date:months.October')
        },
        {
            id: 11,
            text: t('date:months.November')
        },
        {
            id: 12,
            text: t('date:months.December')
        }
    ], [t]);

    const handleChange = ({ id }) => {
        onChange(id);
    }

    useEffect(() => {
        if (!('startingOn' in value)) {
            onChange(1);
        }
    }, [value, onChange]);

    return (
        <div className="resource-repeat-row">
            <div className="row-label">
                Starting on
                {/*{ t('Date of (month day)') }*/}
            </div>

            <div className="row-value">
                <div className="row-input">
                    <Select
                        small={true}
                        selected={value.startingOn}
                        options={months}
                        onChange={handleChange}
                    />
                </div>

                <small className="input-helper">
                    ({ t('startingOnHelper') })
                </small>
            </div>
        </div>
    );
}

export default StartingOnSelector;
